import { Injectable } from '@angular/core';
// import { ToastrService } from 'ngx-toastr';
import { ToastrManager } from 'ng6-toastr-notifications';

@Injectable({
  providedIn: 'root'
})
export class toastmessagesService {

  constructor(private toastr: ToastrManager) { }

  messageHandler(type, message)
  {
    this.toastr[type](message);
  }
}
